var base = require('kiosk/users');

Vue.component('spark-kiosk-users', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/kiosk/users.js